import { render, staticRenderFns } from "./DragAndDropUpload.vue?vue&type=template&id=1dc0dae4&"
import script from "./DragAndDropUpload.vue?vue&type=script&lang=ts&"
export * from "./DragAndDropUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports